import React from 'react';
import { Wrapper } from './FloatingMenu.styles';

export interface Props {
  position?: 'fixed' | 'sticky';
  animationDelay?: number;
  children: React.ReactNode;
}

export const FloatingMenu = ({ animationDelay, position = 'fixed', children, ...rest }: Props) => {
  return (
    <Wrapper
      initial={{ y: '100%', ...(position === 'fixed' ? { x: '-50%' } : {}) }}
      animate={{ y: -20 }}
      transition={{ duration: 1, delay: animationDelay || 0 }}
      position={position}
      {...rest}
    >
      {children}
    </Wrapper>
  );
};
